import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import useCountDown from "../../../../MainComponents/Hooks/useCountDown";

const StudentCoursesCard = ({ teacher, course }) => {
  const navigate = useNavigate();
  const { days, hours, minutes, seconds } = useCountDown(course.expire_at);

  const coursePath = teacher
    ? `/admin/courses/${course.key}`
    : `/courses/${course.key}`;

  const isOpen = course.is_available || course.price === 0;

  return (
    <article className="student-course-card">
      <div
        className="student-course-card__media"
        onClick={() => navigate(coursePath)}
      >
        <img src={course.img} alt={course.title} loading="lazy" />
        {!teacher && (
          <span
            className={`student-course-card__status ${
              isOpen
                ? "student-course-card__status--open"
                : "student-course-card__status--locked"
            }`}
          >
            <FontAwesomeIcon icon={isOpen ? faUnlock : faLock} />
            {isOpen ? "Unlocked" : "Locked"}
          </span>
        )}
      </div>

      <div className="student-course-card__body">
        <div className="student-course-card__meta">
          {course.branch && (
            <span className="student-course-card__badge">{course.branch}</span>
          )}
          {course.n_sessions != null && (
            <p className="student-course-card__sessions">
              {course.n_sessions} sessions
            </p>
          )}
        </div>

        <h2 className="student-course-card__title">
          <Link to={coursePath}>{course.title}</Link>
        </h2>

        {course.description && (
          <p className="student-course-card__desc">{course.description}</p>
        )}

        <div className="student-course-card__footer">
          {!course.is_available && (
            <p className="student-course-card__price">
              {course.price === 0 ? "Free" : `${course.price} EGP`}
            </p>
          )}

          {teacher ? (
            <div className="flex w-full items-center justify-end gap-3">
              <Link
                to="/"
                className="delete-btn bg-delete text-bg w-16 py-[6px] font-semibold rounded-2xl text-center border-2 border-delete hover:bg-bg hover:text-delete transition-all duration-300 hover:scale-105 active:scale-90"
              >
                Delete
              </Link>
              <Link
                to={`/admin/courses/edit-course/${course.key}`}
                className="edit-btn bg-edit text-bg w-16 py-[6px] font-semibold rounded-2xl text-center border-2 border-edit hover:bg-bg hover:text-edit transition-all duration-300 hover:scale-105 active:scale-90"
              >
                Edit
              </Link>
            </div>
          ) : (
            <>
              {course.is_available && (
                <div className="student-course-card__countdown">
                  <p>Expires after</p>
                  <strong>
                    {days}d : {hours}h : {minutes}m : {seconds}s
                  </strong>
                </div>
              )}

              <Link to={coursePath} className="student-course-card__btn">
                {isOpen ? (
                  <>
                    <FontAwesomeIcon icon={faUnlock} />
                    View Lecture
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faLock} />
                    Enroll Now
                  </>
                )}
              </Link>
            </>
          )}
        </div>
      </div>
    </article>
  );
};

export default StudentCoursesCard;
